import { render, staticRenderFns } from "./numWarning.vue?vue&type=template&id=5fc24d66&"
import script from "./numWarning.vue?vue&type=script&lang=js&"
export * from "./numWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports